import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Testimonials() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/testimonials`).then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section id="reviews" data-testid="testimonials-section" className="py-28 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-14"
        >
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-gold/80 mb-4">Client Words</p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-[#F8F6F0] tracking-tight max-w-2xl">
            Trade owners, <span className="gold-text italic">in their own words.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <motion.figure
              key={t.id}
              data-testid={`testimonial-card-${i}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="spotlight-card rounded-2xl border gold-border-subtle bg-surface/60 p-8 flex flex-col hover:border-gold/40 transition-colors duration-500"
            >
              <Quote size={26} className="text-gold/50 mb-5" strokeWidth={1.5} />
              <blockquote className="font-serif text-xl text-[#F8F6F0] leading-relaxed flex-1">"{t.quote}"</blockquote>
              <div className="flex gap-1 mt-6 mb-4">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={13} className="fill-gold text-gold" />
                ))}
              </div>
              <figcaption>
                <div className="font-sans font-semibold text-sm text-[#F8F6F0]">{t.author}</div>
                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 mt-1">
                  {t.business}{t.trade ? ` · ${t.trade}` : ""}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
